import React from "react";
import Candidate from "../../apiResources/Candidate";
import Application from "../../apiResources/Application";
import JobApplicationDetails from "./JobApplicationDetails";
import JobApplicationsModal from "./JobApplicationsModal";
import {
  Wrapper,
  Title,
  Body,
  ReadMore,
  ReadMoreButton,
} from "./styles/box-styles";
import { useModal } from "../../hooks";

const JobApplications = (props: Props) => {
  const modal = useModal(false);
  const { applications, candidate } = props;

  const hasNoApplication = applications.length > 0;
  const hasMoreThanThreeJobs = applications.length > 3;

  return (
    <Wrapper className="animated delay-3 fadeIn" jobsSubmittedFor>
      <Title>Jobs Applications</Title>
      {hasNoApplication ? (
        <Body jobsSubmittedFor>
          {applications.map((application) => (
            <JobApplicationDetails
              key={application.id}
              application={application}
            />
          ))}
          {hasMoreThanThreeJobs && (
            <ReadMore>
              <ReadMoreButton onClick={modal.open}>see more</ReadMoreButton>
            </ReadMore>
          )}
        </Body>
      ) : (
        <Body additionalInfo noData>
          no data
        </Body>
      )}
      {modal.isOpen && (
        <JobApplicationsModal
          candidate={candidate}
          applications={applications}
          onDismiss={modal.close}
        />
      )}
    </Wrapper>
  );
};

type Props = {
  applications: Application[];
  candidate: Candidate;
};

export default JobApplications;
